$(document).ready(function() {
    scroll();

    // Oculta header cuando el usuario scrollea hacia abajo y lo muestra cuando scrollea hacia arriba
    let didScroll;
    let lastScrollTop = 0;
    let delta = 5;
    let navbarHeight = $('header').outerHeight();

    $(window).scroll(function(event) {
        didScroll = true;
    });

    setInterval(function() {
        if (didScroll) {
            hasScrolled();
            didScroll = false;
        }
    }, 250);

    function hasScrolled() {
        let st = $(window).scrollTop();

        if (st > 60) {
            $('header').removeClass('nav-up');

            var titulo = $('.encabezado h1')[0].textContent;
            var seguir = $('.encabezado .seguir').html();
            var labelTitulo_fijo = document.querySelector('.titulo-fijo');
            if (labelTitulo_fijo) {
                labelTitulo_fijo.innerHTML = titulo;
            }

            $('.titulo-seguir').html(seguir);


            //indices
            if ($('main.indices').length) {
                $('header').addClass('acu-fijo');
                $('header').removeClass('home');
            }

        } else {
            $('header').addClass('nav-up');
            $('header').removeClass('nav-down');
            $('header').removeClass('acu-fijo');


            if ($('body.bomba').length) {
                $('header').addClass('transparente');
            }

            if ($('header.nav-up.nav-down').length) {
                $('header').removeClass('nav-down');
            }

        }

        // Make sure they scroll more than delta
        if (Math.abs(lastScrollTop - st) <= delta)
            return;

        // If they scrolled down and are past the navbar, add class .nav-up.
        // This is necessary so you never see what is "behind" the navbar.
        if (st > lastScrollTop && st > navbarHeight) {
            // Scroll up
            $('header').addClass('acu-fijo').removeClass('nav-down');
            $('.scroll-links').slideUp();
        } else {
            // Scroll down
            if (st + $(window).height() < $(document).height()) {
                $('header').removeClass('nav-down').addClass('nav-down');
                $('.scroll-links').slideDown();
            }
        }
        if ($('header.nav-up.nav-down').length) {
            $('header').removeClass('nav-down');
        }
        if (st > 180) {
            $('.banner.sticky2').addClass('up');
            $('.banner.sticky2').css('top', '52px');
        } else {
            if ($('header').hasClass('nav-up')) {
                $('.banner.sticky2').removeClass('up');
            }
        }

        lastScrollTop = st;

    }



    //ESTO ES EL MISMO QUE EST� EN COMMON, PERO CON EL HTML PLANO EL OTRO NO FUNCIONA, cuando lo tomen ustedes funcionar� con el common
    menu();
    menuBusqueda();
    linksImpresa();
    arriba();


    function arriba() {
        $(".volver").click(function(event) {
            event.preventDefault();
            $("html, body").animate({ scrollTop: 0 }, 600);
            return false;
        });
    };



    function menu() {
        $(".icon-menu-desktop").click(function(event) {
            if ($('header').hasClass('desplegado')) {
                $('.icon-menu-desktop').html('MEN&Uacute');
                $('header').removeClass('desplegado-busqueda');
                $('header').removeClass('desplegado');
            } else {
                $('header').addClass('desplegado');
                $('.icon-menu-desktop').html('CERRAR');
            }
            if ($('header').hasClass('desplegado-busqueda') && $('.icon-menu-desktop').html('CERRAR')) {
                $('.icon-menu-desktop').html('MEN&Uacute');
                $('header').removeClass('desplegado-busqueda');
                $('header').removeClass('desplegado');
            }
            if ($(window).width() < 1024) {
                if ($('body').hasClass('sinScroll')) {
                    $('body').removeClass('sinScroll');
                } else {
                    $('body').addClass('sinScroll');
                }
            }

            //Cierre del menú

            $('html').click(function(e) {
                if (e.target.id != 'header' && $(e.target).parents('header').length == 0) {
                    $('.icon-menu-desktop').html('MENÚ');
                    $('header').removeClass('desplegado-busqueda');
                    $('header').removeClass('desplegado');

                }
            })

        });
    }


    function menuBusqueda() {
        $('.busqueda input').focus(function() {
            /*$('header').addClass('desplegado-busqueda');
            $('header').removeClass('desplegado');
            $('.icon-menu-desktop').html('CERRAR');*/
        })
    }

    function linksImpresa() {
        $("#acumulado.edicion-impresa .cuerpo .listado>div .pie ul li a").on('click', function(event) {
            if (this.hash !== "") {
                event.preventDefault();
                let hash = this.hash;
                $('html, body').animate({
                    scrollTop: $(hash).offset().top + -75
                }, 800, function() {
                    //window.location.hash = hash;
                });
            }
        });
    }


})


// WEBPACK FOOTER //
// ./Statics/scripts/acumulado/functions.js